import {
  Pencil, Paperclip, Clock, MessageSquare, Copy,
  UserRound, ExternalLink
} from "lucide-react";
import { FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { generatePDF } from "../components/PdfModel"; // path check kar lena

export default function HistoryTools({ onEdit,onAttachment,onHistory,onComments,onUser,onOpen}) {
  const navigate = useNavigate();
  return (
    <td className="historyTools">
      <button title="Edit"       onClick={onEdit}><Pencil size={16} /></button>
      {/* <button title="Attachment" onClick={onAttachment}> <Paperclip size={16} /></button>
      <button title="History" onClick={onHistory}>  <Clock size={16} /></button>
      <button title="Comments" onClick={onComments}> <MessageSquare size={16} /></button>
      <button title="Copy">     <Copy size={16} /></button>
      <button title="User" onClick={onUser}>     <UserRound size={16} /></button>
      <button title="Open" onClick={onOpen}>     <ExternalLink size={16} /></button>
     <button title="PDF" onClick={generatePDF}>
  <FaFilePdf size={16} />
</button> */}
      {/* <button title="PDF Search" style={{ color: '#ef4444' }}><FaFilePdf size={16} /></button> */}
    </td>
  );
}